import { render } from "./FpuiInputImage.vue?vue&type=template&id=dd390742&lang=pug"
import script from "./FpuiInputImage.vue?vue&type=script&lang=js"
export * from "./FpuiInputImage.vue?vue&type=script&lang=js"

import "./FpuiInputImage.vue?vue&type=style&index=0&id=dd390742&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__